import { Component, OnInit } from '@angular/core';

import {LanguageService} from '../../language/language.service';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-hurtownie-danych',
  templateUrl: './hurtownie-danych.component.html',
  styleUrls: ['../pages.scss','./hurtownie-danych.component.scss']
})
export class HurtownieDanychComponent implements OnInit {

  constructor(
    private meta: Meta,
    private titleService: Title,
    public languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.languageService.getLang('data warehouses title', 'seo'));
    this.meta.updateTag({
      name: 'description',
      content: this.languageService.getLang('data warehouses desc', 'seo')
    });
  }
}
